/** @format */

import React, { useCallback, useEffect, useRef, useState } from "react";
import Container from "react-bootstrap/Container";
import UserContext, { AddAllUserName, getReferUser, getUserInfo, saveDisplayName, saveUsername, storeAllPlatFormUserId } from "./Contexts/User";
import FollowerContext, { getFollowerInfo } from "./Contexts/FollowersInfo";
import { texts } from './Components/LoginComponent/texts'
import { NotificationProps, UserProps } from "./common/models/User";
import { getAuth, onAuthStateChanged, User } from "firebase/auth";
import TelegramAnalytics from '@telegram-apps/analytics'
import VTELogo from "./assets/HomePageImage/NewIcons/Img10.png";

import {
  Navigate,
  Route,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { toast, ToastContainer, Zoom } from "react-toastify";
import Home from "./Pages/Home";
import FrontPage from "./Pages/FrontPage/FrontPage";
import Profile, { ProfileTabs } from "./Pages/Profile";
import FollowerProfile, { FollowerProfileTabs } from "./Pages/FollowerProfile";
import Header from "./Components/Header/Header";
import NotificationContext, { ToastType } from "./Contexts/Notification";
import CoinsContext, { Leader, Totals } from "./Contexts/CoinsContext";
import SingleCoin from "./Pages/SingleCoin";
import {
  Coin,
  DBCoin,
  DBPair,
  getAllCoins,
  getCoins,
  saveAllCoins,
  saveCoins,
} from "./common/models/Coin";
import {
  collection,
  doc,
  onSnapshot,
  query,
  setDoc,
  getDoc,
  where,
} from "firebase/firestore";
import { auth, V2EParliament, db, functions, messaging } from "./firebase";
import Admin from "./Pages/Admin";
import { TimeFrame, VoteResultProps } from "./common/models/Vote";
import AppContext, {
  AppStats,
  CPMSettings,
  PaxData,
  VoteRules,
} from "./Contexts/AppContext";
import isNumber from "lodash/isNumber";
import {
  defaultUserType,
  UserTypeProps,
  validateTotalShare,
} from "./common/models/UserType";
import ManagersContext from "./Contexts/ManagersContext";
import CPMSettingsManager from "./managers/CPMSettingsManager";
import VoteRulesManager from "./managers/VoteRulesManager";
import TimeframesManager from "./managers/TimeframesManager";
import UserTypeManager from "./managers/UserTypeManager";
import CoinMain from "./Pages/CoinMain";
import firebase from "firebase/compat/app";
import PairsMain from "./Pages/PairsMain";
import CardShow from "./Components/Pairs/CardShow";
import SinglePair from "./Pages/SinglePair";
import { ENGLISH, translations } from "./common/models/Dictionary";
import { getKeyByLang, getLangByKey } from "./common/consts/languages";
import { Form } from "react-bootstrap";
import { rest, ws } from "./common/models/Socket";
import { httpsCallable } from "firebase/functions";
import ContentContext, { ContentPage } from "./Contexts/ContentContext";
import Content from "./Pages/Content";
import LoginAndSignup from "./Components/LoginComponent/LoginAndSignup";
import { createWeb3Modal, defaultConfig } from "@web3modal/ethers5/react";
import {
  LoginAuthProvider,
  LoginRegular,
  Logout,
  SignupRegular,
} from "./common/models/Login";
import FirstTimeLogin from "./Components/LoginComponent/FirstTimeLogin";
import { generateUsername } from "./common/utils/strings";
import { intersection } from "lodash";
import Logo, { Size } from "./Components/Atoms/Logo";
import {
  AppContainer,
  getSubdomain,
  HomeContainer,
  isV1,
} from "./Components/App/App";
import Influencers from "./Pages/Influencers";
import NFTGallery from "./Pages/NFTGallery";
import NFTGalleryType from "./Pages/NFTGalleryType";
import Footer from "./Components/Footer";
import PersonalInfo from "./Components/Profile/PersonalInfo";
import Security from "./Components/Profile/Security";
import Mine from "./Components/Profile/Mine";
import Follow from "./Components/Profile/Follow";
import Pool from "./Components/Profile/Pool";
import { useWindowSize } from "./hooks/useWindowSize";
import Votes from "./Components/Profile/Votes";
import { ToastContent, ToastOptions } from "react-toastify/dist/types";
import FAQ from "./Pages/FAQ";
import { myPages, quotes } from "./common/consts/contents";
import Notifications from "./Components/Profile/Notifications";
import Background from "./Components/Background";
import Spinner from "./Components/Spinner";
import Button from "./Components/Atoms/Button/Button";
import FirstTimeAvatarSelection from "./Components/LoginComponent/FirstTimeAvatarSelection";
// import Wallet from "./Components/Profile/Wallet";
import Wallet from './Components/Profile/ Wallet/Wallet';
import WalletDetails from './Components/Profile/ Wallet/WalletDetails';
import { pwaInstallHandler } from 'pwa-install-handler'
import Login2fa from "./Components/LoginComponent/Login2fa";
import TermsAndConditions from "./Pages/TermsAndConditions";
import GenericLoginSignup from "./Components/GenericSignup/GenericLoginSignup";
import ProtectedRoutes from "routes/ProtectedRoutes";
import PageNotFound from "Pages/PageNotFound";
import Routes from "routes/Routes";
import SelectBio from "Components/LoginComponent/SelectBio";
import votingParliament from "firebaseVotingParliament";
import sportParliament from "firebaseSportParliament";
import stockParliament from "firebaseStockParliament";
import coinParliament from "firebaseCoinParliament";
import LandingPage from "Pages/LandingPage";
import OneKey from "Components/OneKey";
import RootRedirect from "routes/RootRedirect";
import BuyGet from "Pages/Buy&Get";
import BornToWinCard from "Pages/Buy&Get/BornToWinCard";
import { BuyGetLanding, BuyGetCheckout } from "Pages/BuyGet";
import MyProduct from "Pages/MyProduct/MyProduct";
import VerifyOtpComponent from "Components/LoginComponent/VerifyOtpComponent";
import PaymentHistory from "Components/Profile/Payment/PaymentHistory";
import { cardTradNotificationsCount, getAllNotifications } from "common/utils/helper";
import ContectUs from "Pages/ContactUs";
import { isTelegramWebView } from "Components/LoginComponent/Login";
import { useTelegramLogin } from "Components/LoginComponent/useTelegramlogin";
import TelegramAnalyticsDemo from "Pages/TelegramAnalyticsDemo";
import CoinParliament from "Components/OtherAppIfram/CoinParliament";
import VotingParliament from "Components/OtherAppIfram/VotingParliament";
import SportParliament from "Components/OtherAppIfram/SportParliament";
import StockParliament from "Components/OtherAppIfram/StockParliament";
import PokerParliament from "Components/OtherAppIfram/PokerParliament";
import FunParliament from "Components/OtherAppIfram/FunParliament";
import AminVoting from "Components/OtherAppIfram/AminVoting";

const sendPassword = httpsCallable(functions, "sendPassword");
const localhost = window.location.hostname === "localhost";
// let userData=false
// const request = indexedDB.open("firebaseLocalStorageDb");
// request.onerror = (event) => {
//   console.error("Why didn't you allow my web app to use IndexedDB?!");
// };
// request.onsuccess = (event) => {
// //  @ts-ignore

//   const db = event?.target?.result
//   db
//   .transaction("firebaseLocalStorage")
//   .objectStore("firebaseLocalStorage").getAll().onsuccess = (event:any) => {
//     userData=event.target.result[0]?.value?.uid

//   }
// //   .get("444-44-4444").onsuccess = (event) => {
// // };
// };

declare global {
  interface Window {
    telegramAnalytics?: {
      init: (config: any) => void;
      track: (eventName: string, eventData?: any) => void;
    };
  }
}

// Initialize TG Analytics
const initializeAnalytics = () => {
  try {
    TelegramAnalytics.init({
      token: "eyJhcHBfbmFtZSI6InZvdGVfdG9fZWFybl8iLCJhcHBfdXJsIjoiaHR0cHM6Ly90Lm1lL1ZvdGVUb0Vhcm5Cb3QiLCJhcHBfZG9tYWluIjoiaHR0cHM6Ly9hcHAudm90ZXRvZWFybi5uZXQvIn0=!e8NPn7l8uJEYeN+qZl/00A1fVLfJ+7VcAqJxbuwJ/E4=",
      appName: "vote_to_earn_",
    });
    console.log("TG Analytics initialized successfully");
  } catch (error) {
    console.error("Failed to initialize TG Analytics:", error);
  }
};

function App() {
  const location = useLocation();
  const search = location.search;
  const pathname = location.pathname;
  const langDetector = useRef(null);
  let navigate = useNavigate();
  const { width } = useWindowSize();
  // const scrollPosition = useScrollPosition();
  const [modalOpen, setModalOpen] = useState(false);
  const [displayFullscreen, setDisplayFullscreen] = useState('none')
  const isTelegram = isTelegramWebView();

  // fullscreen mode
  useEffect(() => {
    const modal = document.getElementById("fullscreen-modal");
    window.addEventListener('load', () => {
      setDisplayFullscreen('block')
    });
    // Initialize analytics on component mount
    if (isTelegram) {
      initializeAnalytics();

      // Track app start event
      trackEvent("app_started", { timestamp: Date.now() });
    }

  }, [])

  const trackEvent = (eventName: string, eventData = {}) => {
    try {
      // Track with TG Analytics using global window object
      if (window.telegramAnalytics && typeof window.telegramAnalytics.track === "function") {
        window.telegramAnalytics.track(eventName, eventData);
      }
    } catch (error) {
      console.error("Error tracking event:", error);
    }
  };

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  // @ts-ignore
  const fullscreenEnabled = document.fullscreenEnabled || document?.webkitFullscreenEnabled || document?.mozFullScreenEnabled || document?.msFullscreenEnabled;

  const handleClick = () => {

    setDisplayFullscreen('none')
    if (isMobile && fullscreenEnabled) {
      const elem = document.documentElement;
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      }
      // @ts-ignore
      else if (elem?.webkitRequestFullscreen) {
        // @ts-ignore
        elem?.webkitRequestFullscreen();
      }
      // @ts-ignore 
      else if (elem?.mozRequestFullScreen) {
        // @ts-ignore
        elem?.mozRequestFullScreen();
      }
      // @ts-ignore
      else if (elem?.msRequestFullscreen) {
        // @ts-ignore
        elem?.msRequestFullscreen();
      }
    }
  }
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, [pathname])

  const showToast = useCallback(
    (
      content: ToastContent,
      type?: ToastType,
      options: ToastOptions | undefined = {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        containerId: "toast",
      }
    ) => {
      switch (type) {
        case ToastType.ERROR:
          toast.error(content, options);
          break;
        case ToastType.INFO:
          toast.info(content, options);
          break;
        default:
          toast.success(content, options);
      }
    },
    []
  );

  const showModal = useCallback(
    (
      content: ToastContent,
      options: ToastOptions | undefined = {
        position: "top-center",
        autoClose: false,
        hideProgressBar: true,
        closeOnClick: false,
        closeButton: true,
        draggable: false,
        progress: undefined,
        containerId: "modal",
        transition: Zoom,
        onOpen: () => setModalOpen(true),
        onClose: () => setModalOpen(false),
      }
    ) => {
      toast(content, options);
    },
    []
  );

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator?.serviceWorker?.addEventListener("message", (message) => {
        const {
          notification: { body, title },
        } = message.data["firebase-messaging-msg-data"] as {
          notification: { body: string; title: string };
        };

        // showToast(
        //   <div>
        //     <h5>{title}</h5>
        //     <p>{body}</p>
        //   </div>
        // );
      });
    }
  });
  useEffect(() => {
    const body = document.querySelector("body") as HTMLBodyElement;
    const classes = pathname
      .slice(1)
      .split("/")
      .filter((c) => c);
    body.classList.remove(...Array.from(body.classList));
    if (
      intersection(classes, ["coins", "pairs"]).length &&
      classes.length > 1
    ) {
      classes.push("single");
    }
    classes.forEach((c) => body.classList.add(c.toLowerCase()));
  }, [pathname]);
  // const [allCoins, setAllCoins] = useState<string[]>(getAllCoins());

  // const [allPairs, setAllPairs] = useState<Array<string[]>>([]);
  const [allPairs, setAllPairs] = useState<Array<string[]>>([["BTC", "ETH"], ["BTC", "ETH"], ["BTC", "ETH"],]);
  const [appStats, setAppStats] = useState<AppStats>({} as AppStats);
  const [paxData, setPaxData] = useState<PaxData>({} as PaxData);
  const [authStateChanged, setAuthStateChanged] = useState(false);
  const [allButtonTime, setAllButtonTime] = useState<any>([]);
  const [allPariButtonTime, setAllPariButtonTime] = useState<any>([]);
  const [singalCardData, setSingalCardData] = useState<any>([]);
  const [nftAlbumData, setNftAlbumData] = useState<any>();
  const [forRun, setForRun] = useState<any>(0);
  const [backgrounHide, setBackgrounHide] = useState<any>(false)
  const [notifications, setNotifications] = useState<NotificationProps[]>([]);
  const [historyTab, setHistoryTab] = useState("Purchase History");
  const [pages, setPages] = useState<ContentPage[] | undefined>(myPages);
  const [buyProduct, setBuyProduct] = useState({});
  const projectId = "1556d7953ee6f664810aacaad77addb1";
  const mainnet = [
    {
      chainId: 1,
      name: "Ethereum",
      currency: "ETH",
      explorerUrl: "https://etherscan.io",
      rpcUrl: "https://eth.llamarpc.com", // More reliable than cloudflare-eth.com
    },
    // {
    //   chainId: 11155111,
    //   name: "Sepolia",
    //   currency: "ETH",
    //   explorerUrl: "https://sepolia.etherscan.io",
    //   rpcUrl: "https://ethereum-sepolia.blockpi.network/v1/rpc/public",
    // },
    {
      chainId: 56,
      name: "Binance",
      currency: "BNB",
      explorerUrl: "https://bscscan.com",
      rpcUrl: "https://bsc-dataseed1.binance.org/", // More reliable endpoint
    },
    {
      chainId: 137,
      name: "Polygon Mainnet",
      currency: "MATIC",
      explorerUrl: "https://polygonscan.com/",
      rpcUrl: "https://polygon-rpc.com/",
    },
    //   {
    //     chainId: 728126428,
    //     name: 'Tron',
    //     currency: 'TRX',
    //     explorerUrl: 'https://tronscan.org',
    //     rpcUrl: 'https://api.trongrid.io'
    // }
  ];

  const metadata = {
    name: "Vote To Earn",
    description: "Vote To Earn",
    url: "https://app.votetoearn.net/",
    icons: ["https://app.votetoearn.net/static/media/logoiconxbig2.7f0c3f73.png"],
  };

  createWeb3Modal({
    ethersConfig: defaultConfig({ metadata }),
    chains: mainnet,
    projectId,
    themeVariables: {
      "--w3m-z-index": 1000,
    },
  });
  // const [coins, setCoins] = useState<{ [symbol: string]: Coin }>(
  //   getCoins() as { [symbol: string]: Coin }
  // );
  const [coins, setCoins] = useState<{ [symbol: string]: Coin }>(
    {
      DEMO: {
        id: 4,
        name: "Cardano",
        price: 0.2738,
        symbol: "ADA",
        trend: 2.11,
      },
      DEMO2: {
        id: 4,
        name: "Cardano",
        price: 0.2738,
        symbol: "ADA",
        trend: 2.11,
      },

      DEMO3: {
        id: 4,
        name: "Cardano",
        price: 0.2738,
        symbol: "ADA",
        trend: 2.11,
      },
      DEMO4: {
        id: 4,
        name: "Cardano",
        price: 0.2738,
        symbol: "ADA",
        trend: 2.11,
      },
      DEMO5: {
        id: 4,
        name: "Cardano",
        price: 0.2738,
        symbol: "ADA",
        trend: 2.11,
      },
      DEMO6: {
        id: 4,
        name: "Cardano",
        price: 0.2738,
        symbol: "ADA",
        trend: 2.11,
      }
    }
  );
  const [loader, setLoader] = useState(false);
  const [mounted, setMounted] = useState(false);
  const [login, setLogin] = useState(false);
  const [signup, setSignup] = useState(false);
  const [firstTimeLogin, setFirstTimeLogin] = useState(false);
  const [showMenubar, setShowMenuBar] = useState(false);
  const [user, setUser] = useState<User>();
  const [userInfo, setUserInfo] = useState<UserProps>();
  const [displayName, setDisplayName] = useState<string>("");
  const [leaders, setLeaders] = useState<Leader[]>([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [profileTab, setProfileTab] = useState(ProfileTabs.profile);
  const [firstTimeAvatarSlection, setFirstTimeAvatarSelection] =
    useState(false);
  const [selectBioEdit, setSelectBioEdit] = useState(false);
  const [firstTimeFoundationSelection, setFirstTimeFoundationSelection] =
    useState(false);
  const [loginRedirectMessage, setLoginRedirectMessage] = useState("");
  const [userUid, setUserUid] = useState("");
  const [chosenUserType, setChosenUserType] = useState<string>("");
  const [parentEmailId, setParentEmailId] = useState<string>("");
  const [notificationCount, setNotificationCount] = useState(0)
  const [lang, setLang] = useState<string>(
    getLangByKey(new URLSearchParams(search).get("lang") + "")
  );
  const [totals, setTotals] = useState<{ [key: string]: Totals }>(
    {} as { [key: string]: Totals }
    // "3"
  );
  const [timeframes, setTimeframes] = useState<TimeFrame[]>([]);
  const [voteRules, setVoteRules] = useState<VoteRules>({} as VoteRules);
  const [languages, setLanguages] = useState<string[]>([ENGLISH]);
  const [rtl, setRtl] = useState<string[]>([]);
  const [admin, setAdmin] = useState<boolean | undefined>(undefined);
  const [remainingTimer, setRemainingTimer] = useState(0)
  const [followerUserId, setFollowerUserId] = useState<string>('')
  const [avatarImage, setAvatarImage] = useState<any>(null)
  const [CPMSettings, setCPMSettings] = useState<CPMSettings>(
    {} as CPMSettings
  );
  const [votesLast24Hours, setVotesLast24Hours] = useState<VoteResultProps[]>(
    []
  );
  const [userTypes, setUserTypes] = useState<UserTypeProps[]>([
    defaultUserType,
  ] as UserTypeProps[]);
  const [supportsPWA, setSupportsPWA] = useState(false);
  const [promptInstall, setPromptInstall] = useState(null);
  const [pwaPopUp, setPwaPopUp] = useState(() => {
    // Check if PWA is already installed or dismissed
    const isPWAInstalled = window.matchMedia("(display-mode: standalone)").matches;
    const pwaDismissed = localStorage.getItem("pwaDismissed");
    return (isPWAInstalled || pwaDismissed === "true") ? "none" : "block";
  });
  const [showPwaModal, setShowPwaModal] = useState(false);
  const [selectedPlatform, setSelectedPlatform] = useState<"ios" | "android" | "web">("ios");
  const [mfaLogin, setMfaLogin] = useState(false)
  useEffect(() => {
    const handler = (e: any) => {
      e.preventDefault();
      setSupportsPWA(true);
      setPromptInstall(e);
    };
    window.addEventListener("beforeinstallprompt", handler);

    return () => window.removeEventListener("transitionend", handler);
  }, []);
  // @ts-ignore
  // useEffect(() => {
  //   const isMFAPassed = window.localStorage.getItem('mfa_passed')
  //   if (isMFAPassed == 'true' && !login) {

  //     // @ts-ignore
  //     Logout(setUser)
  //   }
  // }, [])


  const onClick = (evt: any) => {
    // evt.preventDefault();
    if (!promptInstall) {
      return;
    }
    // @ts-ignore
    else promptInstall.prompt();
  };
  if (!supportsPWA) {

  }

  const updateUser = useCallback(async (user?: User) => {
    setUser(user);

    const info = await getUserInfo(user);

    try {
      const documentRef = V2EParliament.firestore().collection('users').doc(user?.uid);
      const doc = await documentRef.get();
      if (doc.exists) {
        // @ts-ignore
        setUserInfo(doc.data());
      }
    } catch (error) { }
    // setUserInfo(info);
    setDisplayName(info.displayName + "");
  }, []);



  useEffect(() => {
    // const buttons = document.getElementsByTagName('button');
    // for (let i = 0; i < buttons.length; i++) {
    //   buttons[i].addEventListener('click', handleSoundClick);
    // }

    const refer = new URLSearchParams(search).get("refer");
    if (refer && !user) {
      setLogin(false);
      setSignup(false);
    } else {
      const isMFAPassed = window.localStorage.getItem('mfa_passed')
      if (!user && isMFAPassed !== 'true') {
        setLogin(false);
        setSignup(false);
      }

    }
    // return () => {
    //   for (let i = 0; i < buttons.length; i++) {
    //     buttons[i].removeEventListener('click', handleSoundClick);
    //   }
    // }
    if (auth?.currentUser) {
      setLogin(false);
    }
  }, [location, search, JSON.stringify(auth?.currentUser)]);

  // useEffect(() => {
  //   if (!user) {
  //     navigate("/", {replace: true});
  //   }
  // }, [user]);

  useEffect(() => {

    // @ts-ignore
    if (userInfo?.firstTimeLogin) {
      setFirstTimeLogin(true);
      setShowMenuBar(true);
    }
    // @ts-ignore
  }, [userInfo?.firstTimeLogin]);
  useEffect(() => {
    pwaInstallHandler.addListener((canInstall) => {
      canInstall ? setPwaPopUp('block') : setPwaPopUp('none')
    })
  }, [])

  useEffect(() => {
    setMounted(true);
  }, [firstTimeLogin]);

  const [fcmToken, setFcmToken] = useState<string>("");
  const CPMSettingsMng = new CPMSettingsManager(CPMSettings, setCPMSettings);
  const VoteRulesMng = new VoteRulesManager(voteRules, setVoteRules);
  const TimeframesMng = new TimeframesManager(timeframes, setTimeframes);
  const UserTypeMng = new UserTypeManager(userTypes, setUserTypes);




  if (langDetector.current) {
    (langDetector?.current as unknown as HTMLInputElement)?.addEventListener(
      "change",
      (event) => {
        const target = event.target as HTMLInputElement;
        setLang(
          getLangByKey(new URLSearchParams(search).get("lang") || target.value)
        );
      }
    );
  }

  useEffect(() => {
    const localStorageLang = localStorage.getItem("lang");
    if (localStorageLang && languages.includes(localStorageLang)) {
      setMounted(true);
    }
  }, [languages]);
  useEffect(() => {
    if (user?.uid) {
      setDoc(doc(db, "users", user?.uid), { lang }, { merge: true }).then(
        void 0
      );
      if (user?.uid) {
        getAllNotifications(user?.uid, setNotifications, 10);
        cardTradNotificationsCount(user?.uid, setNotificationCount, 20)
      }
      localStorage.setItem("lang", lang);
    }
    if ((user?.uid && user?.email) || (user?.uid && user?.uid.includes("telegram:"))) {
      storeAllPlatFormUserId(user?.email || user?.uid)
    }
  }, [lang, user?.uid]);


  useEffect(() => {
    const auth = getAuth();

    // if (!firstTimeLogin) {
    onAuthStateChanged(auth, async (user: User | null) => {
      setAuthStateChanged(true);
      if (
        user?.emailVerified ||
        user?.providerData[0]?.providerId === "facebook.com" || user?.uid.includes("telegram:")
      ) {
        setLoginRedirectMessage("");
        await updateUser(user);
        setUserUid(user?.uid);
        onSnapshot(doc(db, "users", user.uid), async (doc) => {
          await setUserInfo(doc.data() as UserProps);
          setDisplayName((doc.data() as UserProps).displayName + "");
        });

        try {
          if (fcmToken) {
            try {
              await setDoc(
                doc(db, "users", user.uid),
                { token: fcmToken },
                { merge: true }
              );
            } catch (e) {
              console.log(e);
            }
          }
        } catch (e) {
          showToast("An error occurred", ToastType.ERROR);
        }
      } else {
        // await updateUser();
      }
    });
    // }
  }, [user, fcmToken, coins, JSON.stringify(auth?.currentUser)]);


  const getpraintId = async () => {
    // let refVale = await getReferUser(V2EParliament.firestore())
    let refVale = await getReferUser(votingParliament.firestore())
  }
  getpraintId()

  useEffect(() => {
    const html = document.querySelector("html") as HTMLElement;
    const key = getKeyByLang(lang);
    html.setAttribute("lang", key);
    if (rtl.includes(lang)) {
      html.setAttribute("dir", "rtl");
    } else {
      html.removeAttribute("dir");
    }
  }, [lang, rtl, user?.uid]);
  const [searchParams] = useSearchParams();
  const [enabled, enable] = useState(true);
  const [password, setPassword] = useState("");
  useEffect(() => {
    if (pathname.toLowerCase().includes('login')) {
      setLogin(true);
    }

  }, [pathname]);


  useEffect(() => {
    let token = searchParams.get("token");
    if (token) {
      firebase
        .auth()
        .signInWithCustomToken(token)
        .then((userCredential) => {
          // User is signed in
          const user = userCredential.user;
          if (user && user?.uid.includes("telegram:")) {
            AfterLoginRedirect()
          } else if (user && !user?.emailVerified) {
            auth.signOut();
            showToast("Please verify your email address.", ToastType.ERROR);
          } else {
            AfterLoginRedirect()
          }

        })
        .catch((error) => {
          // Handle sign-in errors
          console.error("Custom token sign-in error: authenticated", error);
          showToast(error.message, ToastType.ERROR);
        }).finally(() => {
          setLoader(false);
        });
    }
  }, [pathname]);


  const AfterLoginRedirect = () => {
    const redirectUrl = localStorage.getItem("redirectUrl")
    if (redirectUrl) {
      localStorage.removeItem("redirectUrl")
      navigate(redirectUrl);
    } else {
      navigate("/apps");
    }
  }

  const getUserInfoValue = async (uid: string) => {
    const userDocRef = doc(db, "users", uid); // `user.uid` is the document ID
    const userSnap = await getDoc(userDocRef);
    if (userSnap.exists()) {
      const userData = userSnap.data();
      console.log("User data:", userData);
    } else {
      console.log("No such user document!");
    }
  }


  useEffect(() => {
    let refer = searchParams.get('refer');
    if (refer) {
      localStorage.setItem('parentEmail', refer);
    } else {
      localStorage.removeItem('parentEmail');
    }
    const handleContextMenu = (e: any) => e.preventDefault();
    const handleCopy = (e: any) => e.preventDefault();
    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("copy", handleCopy);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("copy", handleCopy);
    };
  }, []);

  const isIPhone = /iPhone/i.test(navigator.userAgent);
  const isAndroid = /Android/i.test(navigator.userAgent);
  const isPWA = window.matchMedia("(display-mode: standalone)").matches;

  useEffect(() => {
    const pwaDismissed = localStorage.getItem("pwaDismissed");

    // Don't show if PWA is already installed or user has dismissed it
    if (isPWA || pwaDismissed === "true") {
      setPwaPopUp("none");
    } else if (!isPWA) {
      // Show banner for non-PWA users who haven't dismissed
      setPwaPopUp("block");
    }

    // Set default platform tab based on device
    if (isIPhone) {
      setSelectedPlatform('ios');
    } else if (isAndroid) {
      setSelectedPlatform('android');
    } else {
      setSelectedPlatform('web');
    }
  }, [isPWA, isIPhone, isAndroid]);

  // useEffect(()=>{
  //   if (userInfo) {   
  //     setFirstTimeAvatarSelection(!userInfo?.avatar)      
  //   }
  // }, [JSON.stringify(userInfo)])

  // console.log((window.screen.width < 767 && sessionStorage.getItem("landing") != 'true'), 'loading');

  // console.log(firstTimeLogin ,firstTimeAvatarSlection ,selectBioEdit, "firstTimeAvatarSelectionallstate")
  return loader ? (
    <Spinner />
  ) : (
    <div>

      {!login &&
        !firstTimeAvatarSlection &&
        !firstTimeFoundationSelection &&
        !selectBioEdit &&
        !isTelegram &&
        pathname.toLowerCase() !== "/livebanner" &&
        pathname !== "/influencerUrl" &&
        pathname !== "/progress-bar" &&
        localStorage.getItem("mfa_passed") != "true" &&
        pwaPopUp === "block" && (
          <>
            {/* Bottom Banner - Install App Prompt */}
            <div className="pwa-bottom-banner">
              <div className="pwa-banner-content">
                <div className="pwa-banner-icon">
                  <img
                    src={VTELogo}
                    alt="V2E Logo"
                    className="pwa-app-logo"
                  />
                </div>
                <div className="pwa-banner-text">
                  <div className="pwa-app-title">
                    <strong>Vote To Earn</strong>
                    <div className="pwa-rating">
                      <span className="pwa-stars">⭐⭐⭐⭐⭐</span>
                      <span className="pwa-rating-score">5.0</span>
                    </div>
                  </div>
                  <div className="pwa-bonus-badge">
                    <span>🎁 Install Bonus 100 VTE</span>
                  </div>
                </div>
                <div className="pwa-install-section">
                  <button
                    className="pwa-banner-button"
                    onClick={() => setShowPwaModal(true)}
                    aria-label="Install app"
                  >
                    Install
                  </button>
                  {/* <span className="pwa-platform-text">iOS and Android</span> */}
                </div>
              </div>
              <button
                className="pwa-banner-close"
                onClick={() => {
                  setPwaPopUp("none");
                  localStorage.setItem("pwaDismissed", "true");
                }}
                aria-label="Close"
              >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z" />
                </svg>
              </button>
            </div>

            {/* Modal Popup - Detailed Instructions */}
            {showPwaModal && (
              <>
                {/* Backdrop overlay */}
                <div
                  className="pwa-modal-backdrop"
                  onClick={() => setShowPwaModal(false)}
                />

                {/* PWA Install Modal */}
                <div className="pwa-modal-container">
                  <div className="pwa-modal-content">
                    {/* Close button */}
                    <button
                      className="pwa-modal-close"
                      onClick={() => setShowPwaModal(false)}
                      aria-label="Close"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="white"
                        height="24"
                        width="24"
                      >
                        <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
                      </svg>
                    </button>

                    {/* Header with gradient background */}
                    <div className="pwa-modal-header">
                      <div className="pwa-header-decoration">
                        <svg width="120" height="120" viewBox="0 0 120 120" fill="none">
                          <rect x="20" y="30" width="80" height="60" rx="8" fill="url(#gift-gradient)" />
                          <path d="M60 20 L70 30 L50 30 Z" fill="#FFD700" />
                          <rect x="55" y="30" width="10" height="60" fill="rgba(255,255,255,0.3)" />
                          <defs>
                            <linearGradient id="gift-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                              <stop offset="0%" stopColor="#6352E8" />
                              <stop offset="100%" stopColor="#D4D0F3" />
                            </linearGradient>
                          </defs>
                        </svg>
                      </div>
                    </div>

                    {/* Title */}
                    <h2 className="pwa-modal-title">Install app</h2>

                    {/* Platform Tabs */}
                    <div className="pwa-platform-tabs">
                      <button
                        className={`pwa-tab ${selectedPlatform === 'ios' ? 'active' : ''}`}
                      // onClick={() => setSelectedPlatform('ios')}
                      >
                        iOS
                      </button>
                      <button
                        className={`pwa-tab ${selectedPlatform === 'android' ? 'active' : ''}`}
                      // onClick={() => setSelectedPlatform('android')}
                      >
                        Android
                      </button>
                      <button
                        className={`pwa-tab ${selectedPlatform === 'web' ? 'active' : ''}`}
                      // onClick={() => setSelectedPlatform('web')}
                      >
                        Web
                      </button>
                    </div>

                    {/* Instructions for iOS */}
                    {selectedPlatform === 'ios' && (
                      <div className="pwa-instructions">
                        {/* <div className="pwa-instruction-image">
                          <div className="pwa-phone-mockup">
                            <svg width="200" height="120" viewBox="0 0 200 120" fill="none">
                              <rect x="50" y="10" width="100" height="100" rx="8" fill="#1a1a1a" />
                              <circle cx="100" cy="60" r="15" fill="#6352E8" />
                              <text x="100" y="95" textAnchor="middle" fill="#999" fontSize="10">
                                Add to Home Screen
                              </text>
                            </svg>
                          </div>
                        </div> */}

                        <div className="pwa-steps">
                          <div className="pwa-step">
                            <span className="pwa-step-number">1</span>
                            <span className="pwa-step-text">Open this page in Safari on your smartphone</span>
                          </div>
                          <div className="pwa-step">
                            <span className="pwa-step-number">2</span>
                            <span className="pwa-step-text">Tap "Share"
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                height="18"
                                width="18"
                                fill="#6352E8"
                                style={{ marginLeft: '4px', verticalAlign: 'middle' }}
                              >
                                <path d="M9.71,6.71,11,5.41V17a1,1,0,0,0,2,0V5.41l1.29,1.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42l-3-3a1,1,0,0,0-1.42,0l-3,3A1,1,0,0,0,9.71,6.71ZM18,9H16a1,1,0,0,0,0,2h2a1,1,0,0,1,1,1v7a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V12a1,1,0,0,1,1-1H8A1,1,0,0,0,8,9H6a3,3,0,0,0-3,3v7a3,3,0,0,0,3,3H18a3,3,0,0,0,3-3V12A3,3,0,0,0,18,9Z" />
                              </svg>
                            </span>
                          </div>
                          <div className="pwa-step">
                            <span className="pwa-step-number">3</span>
                            <span className="pwa-step-text">Select "Add to Home Screen"</span>
                          </div>
                          <div className="pwa-step">
                            <span className="pwa-step-number">4</span>
                            <span className="pwa-step-text">Tap "Add"</span>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Instructions for Android */}
                    {selectedPlatform === 'android' && (
                      <div className="pwa-instructions">
                        {/* <div className="pwa-instruction-image">
                          <div className="pwa-phone-mockup">
                            <svg width="200" height="120" viewBox="0 0 200 120" fill="none">
                              <rect x="50" y="10" width="100" height="100" rx="8" fill="#1a1a1a" />
                              <circle cx="100" cy="50" r="20" fill="#6352E8" />
                              <path d="M100 40 L100 60 M90 50 L110 50" stroke="white" strokeWidth="3" strokeLinecap="round" />
                              <text x="100" y="90" textAnchor="middle" fill="#999" fontSize="10">
                                Download File
                              </text>
                            </svg>
                          </div>
                        </div> */}

                        <div className="pwa-steps">
                          <div className="pwa-step">
                            <span className="pwa-step-number">1</span>
                            <span className="pwa-step-text">Download the app on your smartphone</span>
                          </div>
                          <div className="pwa-step">
                            <span className="pwa-step-number">2</span>
                            <span className="pwa-step-text">Install it</span>
                          </div>
                        </div>

                        <button
                          className="pwa-download-button"
                          onClick={onClick}
                          aria-label="Download app"
                        >
                          Download
                        </button>
                      </div>
                    )}

                    {/* Instructions for Web/Desktop */}
                    {selectedPlatform === 'web' && (
                      <div className="pwa-instructions">
                        {/* <div className="pwa-instruction-image">
                          <div className="pwa-phone-mockup">
                            <svg width="200" height="120" viewBox="0 0 200 120" fill="none">
                              <rect x="30" y="20" width="140" height="80" rx="8" fill="#1a1a1a" />
                              <circle cx="100" cy="60" r="15" fill="#6352E8" />
                              <path d="M100 52 L100 68 M92 60 L108 60" stroke="white" strokeWidth="2" strokeLinecap="round" />
                              <text x="100" y="95" textAnchor="middle" fill="#999" fontSize="10">
                                Install App
                              </text>
                            </svg>
                          </div>
                        </div> */}

                        <div className="pwa-steps">
                          <div className="pwa-step">
                            <span className="pwa-step-number">1</span>
                            <span className="pwa-step-text">Click the install icon in your browser's address bar (Chrome, Edge, or Safari)</span>
                          </div>
                          <div className="pwa-step">
                            <span className="pwa-step-number">2</span>
                            <span className="pwa-step-text">Or open browser menu (⋮) and select "Install Vote To Earn"</span>
                          </div>
                          <div className="pwa-step">
                            <span className="pwa-step-number">3</span>
                            <span className="pwa-step-text">Click "Install" in the popup dialog</span>
                          </div>
                          <div className="pwa-step">
                            <span className="pwa-step-number">4</span>
                            <span className="pwa-step-text">The app will open in its own window and be added to your applications</span>
                          </div>
                        </div>

                        {supportsPWA && promptInstall && (
                          <button
                            className="pwa-download-button"
                            onClick={onClick}
                            aria-label="Install app"
                          >
                            Install Now
                          </button>
                        )}
                      </div>
                    )}

                    {/* Close button at bottom */}
                    <button
                      className="pwa-close-button"
                      onClick={() => {
                        setShowPwaModal(false);
                        setPwaPopUp("none");
                        localStorage.setItem("pwaDismissed", "true");
                      }}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </>
            )}
          </>
        )}
      {enabled && (
        <NotificationContext.Provider
          value={{
            showToast,
            showModal,
          }}
        >
          <Form.Control
            type='hidden'
            id='lang-detector'
            ref={langDetector}
            onChange={(e) => console.log(e.target.value)}
          />
          <ManagersContext.Provider
            value={{
              CPMSettingsMng,
              VoteRulesMng,
              TimeframesMng,
              UserTypeMng,
            }}
          >
            <AppContext.Provider
              value={{
                notificationCount,
                setNotificationCount,
                buyProduct,
                setBuyProduct,
                historyTab,
                setHistoryTab,
                setBackgrounHide,
                backgrounHide,
                avatarImage,
                setAvatarImage,
                selectBioEdit,
                setSelectBioEdit,
                parentEmailId,
                setParentEmailId,
                setLoader,
                firstTimeAvatarSlection,
                setFirstTimeAvatarSelection,
                followerUserId,
                setFollowerUserId,
                singalCardData,
                setSingalCardData,
                remainingTimer,
                setNftAlbumData,
                nftAlbumData,
                setAllPariButtonTime,
                allPariButtonTime,
                allButtonTime,
                forRun,
                setForRun,
                setAllButtonTime,
                chosenUserType,
                setChosenUserType,
                setLoginRedirectMessage,
                loginRedirectMessage,
                paxData,
                setPaxData,
                appStats,
                setAppStats,
                authStateChanged,
                login,
                setLogin,
                profileTab,
                setProfileTab,
                signup,
                setSignup,
                firstTimeLogin,
                setFirstTimeLogin,
                showMenubar,
                setShowMenuBar,
                menuOpen,
                setMenuOpen,
                fcmToken,
                setFcmToken,
                lang,
                setLang,
                rtl,
                setRtl,
                languages,
                setLanguages,
                translations,
                setTranslations: (newTranslations) => {
                  newTranslations = new Map(newTranslations);
                  translations.clear();
                  newTranslations.forEach(async (value, key) => {
                    translations.set(key, value);
                    await setDoc(doc(db, "translations", key), value);
                  });
                },
                userTypes,
                setUserTypes: async (u: UserTypeProps[]) => {
                  u = UserTypeMng.setter(u);
                  if (validateTotalShare(u)) {
                    await setDoc(
                      doc(db, "settings", "userTypes"),
                      {
                        userTypes: u,
                      },
                      { merge: true }
                    );
                  } else {
                    if (u.every((uu) => uu.share)) {
                      showToast(texts.Total100, ToastType.ERROR);
                    }
                  }
                },
                CPMSettings,
                setCPMSettings: async (settings: CPMSettings) => {
                  settings = CPMSettingsMng.setter(settings);
                  await setDoc(
                    doc(db, "settings", "settings"),
                    {
                      voteRules: voteRules || {},
                      CPMSettings: settings,
                    },
                    { merge: true }
                  );
                },
                voteRules,
                setVoteRules: async (rules: VoteRules) => {
                  rules = VoteRulesMng.setter(rules);
                  await setDoc(
                    doc(db, "settings", "settings"),
                    {
                      voteRules: rules,
                      CPMSettings: CPMSettings || {},
                    },
                    { merge: true }
                  );
                },
                timeframes,
                setTimeframes: async (t: TimeFrame[]) => {
                  t = TimeframesMng.setter(t);
                  await setDoc(
                    doc(db, "settings", "timeframes"),
                    {
                      timeframes: t.filter(
                        (tt) => isNumber(tt.index) && tt.seconds && tt.name
                      ),
                    },
                    { merge: true }
                  );
                },
              }}
            >
              <ContentContext.Provider
                value={{
                  pages,
                  setPages,
                  quotes,
                }}
              >

                <UserContext.Provider
                  value={{
                    notifications,
                    setNotifications,
                    admin,
                    setAdmin,
                    user,
                    userInfo,
                    displayName,
                    setDisplayName,
                    setUser: updateUser,
                    setUserInfo,
                    votesLast24Hours,
                    setVotesLast24Hours,
                  }}
                >
                  {getSubdomain() === "admin" && user && <Admin />}
                  {(getSubdomain() !== "admin" ||
                    (getSubdomain() === "admin" && !user)) && (
                      <>

                        {/* <Background pathname={pathname} /> */}
                        <AppContainer
                          style={{ backgroundColor: pathname.includes("mobilehomepage") ? ("white") : "" }}
                          fluid
                          pathname={pathname}
                          login={login || firstTimeLogin ? "true" : "false"}
                        // width={width}
                        >
                          <Container
                            fluid
                            style={{
                              // background: "#160133",
                              whiteSpace: "normal",
                              wordWrap: "break-word",
                              flexGrow: 1,
                              padding: '0px 0px 0px 0px'
                            }}
                          >
                            {
                              // Hide header on parliament iframe routes
                              !pathname.includes('/coinparliament') &&
                              !pathname.includes('/votingparliament') &&
                              !pathname.includes('/stockparliament') &&
                              !pathname.includes('/sportparliament') &&
                              !pathname.includes('/pokerparliament') &&
                              !pathname.includes('/funparliament') &&
                              !pathname.includes('/aminvoting') &&
                              <Header
                                setMfaLogin={setMfaLogin}
                              />}
                            {/* {user && firstTimeLogin && !firstTimeAvatarSlection && !selectBioEdit &&(
                              <FirstTimeLogin
                                setFirstTimeAvatarSelection={
                                  setFirstTimeAvatarSelection
                                }
                                generate={generateUsername}
                                
                                saveUsername={async (username: any, DisplayName: any) => {  
                                  // @ts-ignore                                  
                                  if (user?.uid) {                                    
                                    await saveUsername(user?.uid, username, "");
                                    await saveDisplayName(user?.uid, DisplayName, "");                                                                                                            
                                    setFirstTimeAvatarSelection(true);
                                    // setFirstTimeFoundationSelection(true);
                                    setFirstTimeLogin(false);
                                  }
                                }}
                              />
                            )} */}

                            {/* {!firstTimeLogin && firstTimeAvatarSlection && !selectBioEdit &&(
                              <FirstTimeAvatarSelection
                                user={user}
                                setFirstTimeAvatarSelection={
                                  setFirstTimeAvatarSelection
                                }
                                setSelectBioEdit={
                                  setSelectBioEdit
                                }
                              />
                            )} */}
                            {/* {!firstTimeLogin && !firstTimeAvatarSlection && selectBioEdit && (
                              <SelectBio
                                userData={user}
                                setSelectBioEdit={
                                  setSelectBioEdit
                                }
                              // setFirstTimeAvatarSelection={
                              //   setFirstTimeAvatarSelection
                              // }
                              />
                            )} */}

                            {(user || userInfo?.uid) && localStorage.getItem('mfa_passed') === 'true' && (
                              <Login2fa
                                setLogin={setLogin}
                                setMfaLogin={setMfaLogin}
                              />
                            )}
                            {!firstTimeLogin && <Routes>
                              <Route path={"coinparliament"} element={<CoinParliament />} />
                              <Route path={"votingparliament"} element={<VotingParliament />} />
                              <Route path={"stockparliament"} element={<StockParliament />} />
                              <Route path={"sportparliament"} element={<SportParliament />} />
                              <Route path={"pokerparliament"} element={<PokerParliament />} />
                              <Route path={"funparliament"} element={<FunParliament />} />
                              <Route path={"aminvoting"} element={<AminVoting />} />
                              <Route path="*" element={<Navigate to="/apps" replace />} />
                              {/* <Route path="/" element={<RootRedirect />} /> */}
                              <Route path='/mobilehomepage' element={<LandingPage />} />
                              {/* <Route path='/' element={<OneKey/>} />     */}
                              <Route path='/' element={
                                (() => {
                                  const hasCachedAuth = localStorage.getItem('mfa_passed') === 'true';
                                  if (hasCachedAuth || user?.uid) {
                                    return <Navigate to="/apps" replace />;
                                  }
                                  return !authStateChanged ? <Spinner /> : <FrontPage />;
                                })()
                              } />
                              <Route path='/apps' element={<Home />} />
                              <Route path='/buyget' element={<BuyGetLanding />} />
                              <Route path='/buy/:slug' element={<BuyGetCheckout />} />
                              <Route path='/buyget-old' element={<BuyGet />} />
                              {/* {(window.screen.width < 767 && sessionStorage.getItem("landing")!='true') && <Route path='/' element={<LandingPage/>} />} */}
                              <Route path='/onekey' element={
                                !userInfo ? (
                                  <LoginAndSignup
                                    {...{
                                      authProvider: LoginAuthProvider,
                                      loginAction: LoginRegular,
                                      signupAction: SignupRegular,
                                    }}
                                  />
                                ) : (
                                  <Navigate to="/apps" replace />
                                )
                              } />
                              {!login &&
                                !firstTimeAvatarSlection &&
                                !firstTimeFoundationSelection && !selectBioEdit && localStorage.getItem('mfa_passed') != 'true' &&
                                <>
                                  <Route path='/sign-up' element={!userInfo ? <GenericLoginSignup authProvider={LoginAuthProvider} /> : <Navigate to="/" />} />
                                  <Route element={<ProtectedRoutes />}>
                                    <Route path={'profile/share'} element={<Pool />} />
                                    <Route path={'buywincard'} element={<BornToWinCard />} />
                                    {/* <Route path={"/TelegramAnalyticsDemo"} element={<TelegramAnalyticsDemo />} /> */}
                                    <Route path={ProfileTabs.profile} element={<Profile />} >
                                      <Route path={'/profile'} element={<Navigate to={'/profile/edit'} />} />
                                      <Route path={ProfileTabs.edit} element={<Security />} />

                                      {/* <Route path={ProfileTabs.edit} element={<PersonalInfo />} /> */}
                                      {/* <Route path={ProfileTabs.password} element={<Security />} /> */}
                                      <Route path={ProfileTabs.wallet} element={<Wallet />} />
                                      <Route path={ProfileTabs.walletDetails} element={<WalletDetails />} />
                                      <Route path={ProfileTabs.product} element={<MyProduct />} />
                                      <Route path={ProfileTabs.history} element={<PaymentHistory />} />
                                      <Route path={ProfileTabs.notifications} element={<Notifications />} />
                                      <Route path={ProfileTabs.contactus} element={<ContectUs />} />

                                    </Route>
                                  </Route>
                                </>}
                            </Routes>}
                          </Container>
                          {/* <Footer /> */}
                        </AppContainer>
                      </>
                    )}
                  <ToastContainer enableMultiContainer containerId='toast' limit={1} />
                  <ToastContainer enableMultiContainer containerId='modal' />
                  {modalOpen && <div className='fade modal-backdrop show' />}
                </UserContext.Provider>
              </ContentContext.Provider>
            </AppContext.Provider>
          </ManagersContext.Provider>
        </NotificationContext.Provider>
      )
      }
      {
        !enabled && (
          <Container>
            <Form
              onSubmit={async (e) => {
                e.preventDefault();
                const resp = await sendPassword({ password });
                console.log(resp.data);
                if (resp.data === true) {
                  enable(true);
                }
              }}
            >
              <Form.Group className='mb-3' controlId='formBasicPassword'>
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type='password'
                  placeholder='Password'
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Form.Group>
              <Button type='submit'>Submit</Button>
            </Form>
          </Container>
        )
      }
    </div >
  );
}

export default App;
export const showToast = (
  content: ToastContent,
  type?: ToastType,
  options: ToastOptions | undefined = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    containerId: "toast",
  }
) => {
  toast.dismiss();
  toast.clearWaitingQueue();
  switch (type) {
    case ToastType.ERROR:
      toast.error(content, options);
      break;
    case ToastType.INFO:
      toast.info(content, options);
      break;
    default:
      toast.success(content, options);
  }
};
